<template>
    <div class="clearfix main_center">

        <div class="right-content">
            <el-form ref="form" :model="form" label-width="180px" :rules="rules" >
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>项目信息</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="项目名称：" size="small" prop="projectName">
                                    <el-select v-model="form.projectName"
                                               placeholder="请选择"
                                               @change="handleChangeProject"
                                    >
                                        <el-option
                                            v-for="item in projectOptions"
                                            :key="item.projectEntryId"
                                            :label="item.projectName"
                                            :value="item.projectEntryId">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="招标（采购）人：" size="small" prop="tendererName">
                                    <el-input v-model="form.tendererName" placeholder="根据选择的项目自动带出" disabled/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="招标（采购）项目内容：" size="small" prop="tenderContent">
                                    <el-input type="textarea"
                                              v-model="form.tenderContent"
                                              placeholder="根据选择的项目自动带出"
                                              disabled
                                              :rows="5"
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>成交概况</span>
                    </div>
                    <div class="form-content default-content">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="中标单位：" size="small" prop="winningCompany">
                                    <el-input v-model="form.winningCompany" placeholder="请输入中标单位" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="中标金额：" size="small" prop="winningAmount">
                                    <el-input v-model="form.winningAmount"
                                              style="width: 80%"
                                    ></el-input>
                                    &nbsp;&nbsp;元
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item label="备注信息：" size="small">
                                    <el-input type="textarea"
                                              v-model="form.remarks"
                                              placeholder="请输入"
                                              :rows="5"
                                              maxlength="500"
                                              show-word-limit
                                    />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-card>
            </el-form>
        </div>
        <div class="left-content">
            <div class="left-navbar">
                <el-button size="small"
                           type="primary"
                           @click="onClickSave"
                           :loading="saveLoading"
                >保存</el-button>
                <el-button size="small"
                           type="primary"
                           @click="onClickSubmit"
                           :loading="submitLoading"
                >提交</el-button>
                <el-button size="small" @click="backBtn">返回</el-button>
            </div>
        </div>

    </div>
</template>

<script>
import {tabsCloseCurrentHandle} from '@/utils/routeTab';

const validateWinningAmount = (rule, value, callback) => {
    //整数位不能超过12位，小数位不能超过2位
    if(!/^\d*\.?\d+$|^\d+\.?\d*$/.test(value)) {
        callback(new Error('中标金额只能输入非负数字'))
    }else if (!/^\d{1,12}(\.\d{1,2})?$/.test(value)) {
        callback(new Error('中标金额整数位不能超过12位，小数位不能超过2位'))
    } else {
        callback()
    }
}

export default {
    data() {
        return {
            id: '',
            form: {},
            projectOptions: [],
            rules: {
                projectName: [
                    { required: true, message: '请选择项目名称', trigger: ['blur', 'change'] },
                ],
                tendererName: [
                    { required: true, message: '请输入招标（采购）联系人', trigger: ['blur', 'change'] },
                ],
                tenderContent: [
                    { required: true, message: '请输入招标（采购）内容', trigger: ['blur', 'change'] },
                ],
                winningCompany: [
                    { required: true, message: '请输入中标单位', trigger: 'blur' },
                ],
                winningAmount: [
                    { required: true, message: '请输入中标金额', trigger: 'blur' },
                    { validator: validateWinningAmount, trigger: 'blur' },
                ],
            },
            saveLoading: false, //保存loading
            submitLoading: false, //提交loading
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        this.requestDetailData();
        this.requestProjectInfo();
    },
    methods: {
        //获取详情数据
        requestDetailData() {
            if (!this.id) {
                return
            }
            this.$http.get(`/bidResultSummary/get?bidResultSummaryId=${this.id}`).then(({data}) => {
                if (data.code === '1') {
                    this.form = {...data.data}
                }
            })
        },
        //获取进场项目下拉框数据
        requestProjectInfo() {
            this.$http.get(`/bidResultSummary/projectInfo`).then(({data}) => {
                this.projectOptions = data
            })
        },
        //选择了项目
        handleChangeProject(val) {
            const selectProject = this.projectOptions.find(item => item.projectEntryId === val)
            if (selectProject) {
                this.form.projectEntryId = selectProject.projectEntryId;
                this.form.projectName = selectProject.projectName;
                this.form.tendererName = selectProject.tendererName;
                this.form.tenderContent = selectProject.tenderContent;
            }
        },
        //保存
        onClickSave() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.saveLoading = true;
                    this.$http.post('/bidResultSummary/saveOrUpdate', this.form).then(({data}) => {
                        if (data.code === '1') {
                            this.form = data.data
                            this.id = this.form.id
                            this.$message.success("保存成功！")
                        } else {
                            this.$message.error(data.msg)
                        }
                    }).finally(() => {
                        this.saveLoading = false;
                    })
                }
            })
        },
        onClickSubmit() { //提交
            if (!this.id) {
                this.$message.error('请先保存数据！')
                return
            }
            const params = {
                ...this.form,
                status: 2,
            }
            this.submitLoading = true;
            this.$http.post('/bidResultSummary/saveOrUpdate', params).then(({data}) => {
                if (data.code === '1') {
                    this.$message.success('提交成功！')
                    setTimeout(() => {
                        this.backBtn()
                    }, 1000)
                } else {
                    this.$message.error(data.msg)
                }
            }).finally(() => {
                this.submitLoading = false;
            })
        },
        getRowsIndex(index) {
            return index + 1
        },
        backBtn() { //返回
            tabsCloseCurrentHandle();
            this.$router.push({
                name: 'singleWindowServiceDealList'
            })
            this.$refs.form.resetFields();
        },
    }


}
</script>

<style lang="less" scoped>
.angle_tag {
    margin-right: 10px !important;
}
</style>
